$(window).on("load",function(){
});
$(function(){

	var $body = $('body');
	
	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/gotojimuki/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		$('body').prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 300) {
			$body.addClass("scroll");
		} else {
			$body.removeClass("scroll");
		}
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.header_sp_btn').on('click', function () {
		$body.toggleClass('open');
		// bodyにopenがあれば
		if($($body).hasClass('open')){
			$('.header_sp_btn_text').html('CLOSE');
		} else {
			$('.header_sp_btn_text').html('MENU');
		}
		return false;
	});

	//メニュー名以外の部分をクリックで閉じる
	$('.layer').on('click', function () {
		$body.removeClass('open');
		$('.header_sp_btn_text').html('MENU');
	});


	//開閉用ボタンをクリックでクラスの切替え
	$('.header_toggle_btn').on('click', function () {
		$(".submenu_lists").css("display", "none");
		
		$(this).toggleClass('on');
		$(this).next(".submenu_lists").toggleClass('on');

		$(".header_toggle_btn").not(this).removeClass("on");
		$(".header_toggle_btn").not(this).next().removeClass("on");

		$(".header_toggle_btn").not(this).next().slideUp(300);
		$(this).next().slideToggle(300);
	});
	//開閉用ボタンをクリックでクラスの切替え
	// $('.header_toggle_btn').on('click', function () {
	// 	$(this).toggleClass('on');
	// 	$(this).next(".submenu_lists").toggleClass('on');
	// });

	//実績スライド(スマホのみ)
	var works_swiper;
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			if (works_swiper) {
				return;
			} else {
				works_swiper = new Swiper('.works_swiper', {
					loop: true,
					// speed: 1500,
					autoplay: {
						delay: 4000,
					},
					spaceBetween: 19,
					slidesPerView: 1.25,
					centeredSlides: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
			}
		} else {
			if (works_swiper) {
				works_swiper.destroy();
				works_swiper = undefined;
			}
		}
	});

	//メインビジュアル
	$('.mv_img').imagesLoaded( function() {
		// 画像を読み込んだ後に実行したい処理
		$('.mv_copy').addClass("animated");
	});

	//メインビジュアル
	$('.lower_mv_img').imagesLoaded( function() {
		// 画像を読み込んだ後に実行したい処理
		$('.lower_visual .section_title').addClass("animated");
	});

});